import script from "./WelcomeBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeBanner.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeBanner.vue?vue&type=style&index=0&id=7cd5307c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd5307c"]])

export default __exports__